var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialingCommitteeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credentialing_Committee_-_Second",
    "data-name": "Credentialing Committee - Second",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133018",
    "data-name": "Path 133018",
    d: "M195.777,320.728l1.553,4.35,2.394-1.8-3.534-2.65Zm0,0",
    transform: "translate(-162.022 -265.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133019",
    "data-name": "Path 133019",
    d: "M214.544,358.069l3.314-9.279L214.136,346l-3.722,2.79,3.314,9.279Zm0,0",
    transform: "translate(-174.136 -286.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133020",
    "data-name": "Path 133020",
    d: "M152.018,205.149a4.077,4.077,0,0,0,2.8,4.309,11.185,11.185,0,0,1-.059-1.14v-6.6a4.166,4.166,0,0,0-2.739,3.431Zm0,0",
    transform: "translate(-125.792 -166.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133021",
    "data-name": "Path 133021",
    d: "M200.552,199.023a16.63,16.63,0,0,1-2.356.168H184v6.9a8.276,8.276,0,0,0,16.552,0Zm0,0",
    transform: "translate(-152.276 -164.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133022",
    "data-name": "Path 133022",
    d: "M249.276,320.728l-.414-.095-3.534,2.65,2.394,1.8Zm0,0",
    transform: "translate(-203.031 -265.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133023",
    "data-name": "Path 133023",
    d: "M216.276,300.791v-1.5a10.947,10.947,0,0,1-8.276,0v1.5l4.138,3.1Zm0,0",
    transform: "translate(-172.138 -247.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133024",
    "data-name": "Path 133024",
    d: "M357.517,119.224V117.64a9.557,9.557,0,0,1-5.517,0v1.583l2.759,9.2Zm0,0",
    transform: "translate(-291.31 -97.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133025",
    "data-name": "Path 133025",
    d: "M334.9,17.931a6.9,6.9,0,0,0,6.9-6.9V6.9A6.9,6.9,0,0,0,328,6.9v4.138A6.9,6.9,0,0,0,334.9,17.931Zm0,0",
    transform: "translate(-271.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133026",
    "data-name": "Path 133026",
    d: "M291.289,176.641H299V165.607h3.663l-2.148-7.165a16.223,16.223,0,0,1-6.251,5.465,6.845,6.845,0,0,1,3.326,5.166,6.832,6.832,0,0,1-6.274,7.507c-.009.021-.016.041-.024.062Zm0,0",
    transform: "translate(-241.067 -131.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133027",
    "data-name": "Path 133027",
    d: "M295.716,201.719v6.6a11.185,11.185,0,0,1-.059,1.14,4.077,4.077,0,0,0,2.8-4.309,4.166,4.166,0,0,0-2.739-3.431Zm0,0",
    transform: "translate(-244.681 -166.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133028",
    "data-name": "Path 133028",
    d: "M171.713,111.172a13.5,13.5,0,0,0,11.083-5.737,13.332,13.332,0,0,1-7.847-4.452l-.445-.517a12.793,12.793,0,0,0-22.5,8.326v3.877a7.246,7.246,0,0,1,4.375-1.5Zm0,0",
    transform: "translate(-125.793 -79.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133029",
    "data-name": "Path 133029",
    d: "M192,432h13.793v5.517H192Zm0,0",
    transform: "translate(-158.897 -357.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133030",
    "data-name": "Path 133030",
    d: "M264.739,326.6l-7.772-1.793-5.616,15.723h6.319v8.276h2.759V333.635h2.759v15.172h6.9V333.322A6.867,6.867,0,0,0,264.739,326.6Zm0,0",
    transform: "translate(-208.015 -268.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133031",
    "data-name": "Path 133031",
    d: "M352,216h5.517v8.276H352Zm0,0",
    transform: "translate(-291.31 -178.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133032",
    "data-name": "Path 133032",
    d: "M112.554,138.739l-2.593-.778-3.208,10.7h3.663v11.034h7.709c-.008-.021-.015-.041-.024-.062a6.757,6.757,0,0,1-6.269-6.835H111.8v-9.277a15.476,15.476,0,0,1,.758-4.779Zm0,0",
    transform: "translate(-88.348 -114.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133033",
    "data-name": "Path 133033",
    d: "M117.117,324.809l-7.772,1.794A6.865,6.865,0,0,0,104,333.322v15.486h6.9V333.635h2.759v15.172h2.759v-8.276h6.319Zm0,0",
    transform: "translate(-86.069 -268.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133034",
    "data-name": "Path 133034",
    d: "M390.5,140.523l-8.541-2.563-3.208,10.7h3.663v11.034h2.759V144.519h2.759v15.172h5.517V144.486a4.11,4.11,0,0,0-2.949-3.963Zm0,0",
    transform: "translate(-313.452 -114.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133035",
    "data-name": "Path 133035",
    d: "M80,216h5.517v8.276H80Zm0,0",
    transform: "translate(-66.207 -178.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133036",
    "data-name": "Path 133036",
    d: "M82.759,118.047A9.6,9.6,0,0,1,80,117.641v1.583l2.759,9.2,2.759-9.2v-1.583A9.6,9.6,0,0,1,82.759,118.047Zm0,0",
    transform: "translate(-66.207 -97.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133037",
    "data-name": "Path 133037",
    d: "M62.9,17.931a6.9,6.9,0,0,0,6.9-6.9V6.9A6.9,6.9,0,0,0,56,6.9v4.138A6.9,6.9,0,0,0,62.9,17.931Zm0,0",
    transform: "translate(-46.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133038",
    "data-name": "Path 133038",
    d: "M11.488,137.961l-8.541,2.563A4.111,4.111,0,0,0,0,144.486v15.205H5.517V144.519H8.276v15.172h2.759V148.657H14.7Zm0,0",
    transform: "translate(0 -114.175)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialingCommitteeHover);
export default __webpack_public_path__ + "static/media/CredentialingCommitteeHover.dc72fd80987b80846d9be282ba8fd002.svg";
export { ForwardRef as ReactComponent };